import { Component, EventEmitter, Input, Output } from "@angular/core";
import { INavItem, NavItemsSectionConfig } from "@webapp/navigation/models/nav-items-list.models";
import { ICollection } from "@gtmhub/models";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import NavigationItemsMediator from "@webapp/navigation/services/uxcustomization/navigation-items.mediator.service";

@Component({
  selector: "gh-nav-items-list",
  templateUrl: "./nav-items-list.component.html",
  styleUrls: ["./nav-items-list.component.less"],
})
export class NavItemsListComponent {
  @Input()
  public config: NavItemsSectionConfig;
  @Input()
  public collection: ICollection<INavItem>;
  @Output()
  public markItemAsFavorite = new EventEmitter<INavItem>();
  @Output()
  public unmarkItemAsFavorite = new EventEmitter<INavItem>();
  public expanded = true;
  public seeMore: boolean;

  public constructor(protected navigationitemsMediator: NavigationItemsMediator) {}

  public drop(event: Partial<CdkDragDrop<string[]>>): void {
    if (event.previousIndex === event.currentIndex || this.config.itemsGroupType !== "favorites") {
      return;
    }

    const item = this.collection.items[event.previousIndex];
    const newOrder = event.currentIndex + 1;

    moveItemInArray(this.collection.items, event.previousIndex, event.currentIndex);

    this.navigationitemsMediator.reorder(item.favoriteId, newOrder);
  }
}
